// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/state-in-constructor, react/destructuring-assignment, class-methods-use-this */
import React from "react"
import { connect } from "react-redux"
import Cookies from "js-cookie" // debug cookies
import styled from "styled-components" // eslint-disable-line no-restricted-imports
import type { Dispatch } from "redux"
import Text from "@kiwicom/orbit-components/lib/Text"
import InputField from "@kiwicom/orbit-components/lib/InputField"
import Button from "@kiwicom/orbit-components/lib/Button"
import * as cookies from "@kiwicom/nitro/lib/services/session/cookies"
import { getBookedAt, getBookedAtScrooge } from "@kiwicom/frontend-common/services/options/reducer"
import { setOption } from "@kiwicom/frontend-common/services/options/actions"
import { setNotice } from "@kiwicom/frontend-common/services/notice"
import RadioButtons from "@kiwicom/frontend-common/components/RadioButtons/RadioButtons"

import SmartFillOptionsList from "./SmartFillOptionsList"
import OptionToggleBtns from "./OptionToggleBtns"
import SetBrand from "./SetBrand"
import SaveLoadSplitster from "./SaveLoadSplitster"
import { Cookie } from "@kiwicom/cookies"

export const FlexWrapper = styled.div`
  display: flex;
`

const ButtonWrapper = styled.div`
  margin: auto 0 0 0;
`
const toggleButtonsOptions = [
  {
    value: "enabled",
    label: "Enable",
  },
  {
    value: "disabled",
    label: "Disable",
  },
]

const smartFillButtonsOptions = [
  {
    value: "enabled",
    label: "Show",
  },
  {
    value: "disabled",
    label: "Hide",
  },
]

const getPreProductionToggleOptions = () => [
  {
    value: "false",
    label: "Production",
  },
  {
    value: "true",
    label: "Pre-Production",
  },
]

type Props = {
  showSmartFillOptions: boolean
  showConsoleLogs: string
  fakeCuckoo: string
  debugUmbrella: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>
  bookedAt?: string
  bookedAtScrooge?: string
}

type State = {
  affilId?: string
  bookedAt?: string
  bookedAtScrooge?: string
}

class DebugTools extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { bookedAt: props.bookedAt, bookedAtScrooge: props.bookedAtScrooge }
  }

  // FIXME: sort methods in React components according to conventions

  handleSubmit = () => {
    ;["affiliateThisSession", "affiliate"].forEach((item) =>
      this.props.dispatch(setOption(item, this.state.affilId)),
    )
    this.setState({ affilId: "" })
    this.props.dispatch(
      setNotice({
        id: "affilIdSet",
        type: "success",
        title: "Success",
        ttl: 3000,
      }),
    )
  }

  handleSetBookedAt = () => {
    this.props.dispatch(setOption("bookedAt", this.state.bookedAt))
  }

  handleSetBookedAtScrooge = () => {
    const { dispatch } = this.props
    const { bookedAtScrooge } = this.state
    dispatch(setOption("bookedAtScrooge", bookedAtScrooge))
  }

  handleClear = () => {
    const { dispatch } = this.props
    this.setState({ affilId: "" })
    dispatch(setOption("affiliateThisSession", ""))

    const defaultSettings = [
      {
        option: "enableHiddenFeatures",
        defaultValue: false,
      },
      {
        option: "showTranslationKeys",
        defaultValue: false,
      },
      {
        option: "showConsoleLogs",
        defaultValue: false,
        saveToCookies: true,
      },
      {
        option: "showReduxLogs",
        defaultValue: false,
        saveToCookies: false,
      },
      {
        option: "debugUmbrella",
        defaultValue: false,
        saveToCookies: true,
      },
      {
        option: "fakeCuckoo",
        defaultValue: false,
        saveToCookies: true,
      },
      {
        option: "showSmartFillOptions",
        defaultValue: false,
      },
    ]

    defaultSettings.forEach((item) => {
      dispatch(setOption(item.option, item.defaultValue))
      if (item.saveToCookies) {
        Cookies.set(
          item.option === "fakeCuckoo" ? "debug_fakeCuckoo" : item.option,
          String(item.defaultValue),
        )
      }
    })

    this.props.dispatch(
      setNotice({
        id: "clearForm",
        type: "success",
        title: "Clear",
        ttl: 3000,
      }),
    )
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleInputChange = (e: React.ChangeEvent<any>) => {
    const {
      target: { name, value },
    } = e
    this.setState({
      [name]: value,
    })
  }

  setPreProduction(newVersion: string) {
    // pre_production cookie tells nginx which Rancher port send request to (with true, requests are send to testing prod env without real traffic)
    Cookies.set("pre_production", newVersion)
    // @ts-expect-error: Flow to TS migration.
    window.location.reload(true)
  }

  renderPreReleaseToggle() {
    const preProductionVersion = Cookies.get("pre_production") ?? "false"

    return (
      <li className="DebugModal-ab-toggle-line" key="pre_production">
        <span>Frontend version: </span>
        <RadioButtons
          // @ts-expect-error: Flow to TS migration.
          label="Frontend version: "
          modes={getPreProductionToggleOptions()}
          active={preProductionVersion}
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/unbound-method
          handleChange={this.setPreProduction}
        />
      </li>
    )
  }

  render() {
    const { showConsoleLogs, fakeCuckoo, debugUmbrella, showSmartFillOptions } = this.props

    return (
      <div>
        <h3>Dev tools</h3>
        {window.SP_GLOBALS.SKYPICKER_ENV === "production" &&
          !window.SP_GLOBALS.IS_STAGING &&
          this.renderPreReleaseToggle()}
        <ul className="DebugModal-buttons-list">
          <li>
            <OptionToggleBtns
              modes={toggleButtonsOptions}
              option="enableHiddenFeatures"
              label="Hidden features"
            />
          </li>
          <li>
            <OptionToggleBtns
              modes={toggleButtonsOptions}
              option="showTranslationKeys"
              label="Show translation keys"
            />
          </li>
          <li>
            <OptionToggleBtns
              modes={toggleButtonsOptions}
              option="showConsoleLogs"
              label="Show console logs"
              handleChange={() => Cookies.set("showConsoleLogs", String(!showConsoleLogs))}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              checkActive={(optionState: any) => optionState === "true" || optionState}
            />
          </li>
          <li>
            <OptionToggleBtns
              modes={toggleButtonsOptions}
              option="debugUmbrella"
              label="Debug Umbrella"
              handleChange={() => Cookies.set("debugUmbrella", String(!debugUmbrella))}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              checkActive={(optionState: any) => optionState === "true" || optionState}
            />
          </li>
          <li>
            <OptionToggleBtns
              modes={toggleButtonsOptions}
              option="fakeCuckoo"
              label="Enable fake cuckoo (console instead of real tracking)"
              handleChange={() => Cookies.set("debug_fakeCuckoo", String(!fakeCuckoo))}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              checkActive={(optionState: any) => optionState === "true" || optionState}
            />
          </li>

          <li>
            <OptionToggleBtns
              modes={smartFillButtonsOptions}
              option="showSmartFillOptions"
              label="Smart fill options"
            />
          </li>
        </ul>
        <FlexWrapper>
          <InputField
            label="AffilId input"
            value={this.state.affilId}
            placeholder="Input affilId"
            name="affilId"
            onChange={this.handleInputChange}
          />
          <ButtonWrapper>
            <Button onClick={this.handleSubmit} fullWidth={false} type="primary" size="normal">
              Submit
            </Button>
          </ButtonWrapper>
        </FlexWrapper>

        <FlexWrapper>
          <InputField
            label="Booked at"
            value={this.state.bookedAt}
            placeholder="Booked at"
            name="bookedAt"
            onChange={this.handleInputChange}
          />
          <ButtonWrapper>
            <Button onClick={this.handleSetBookedAt} fullWidth={false} type="primary" size="normal">
              Submit
            </Button>
          </ButtonWrapper>
        </FlexWrapper>
        <FlexWrapper>
          <InputField
            label="booked_at (MMB extra orders only)"
            value={this.state.bookedAtScrooge}
            placeholder="Defaults to booked_at above"
            name="bookedAtScrooge"
            onChange={this.handleInputChange}
          />
          <ButtonWrapper>
            <Button
              onClick={this.handleSetBookedAtScrooge}
              fullWidth={false}
              type="primary"
              size="normal"
            >
              Submit
            </Button>
          </ButtonWrapper>
        </FlexWrapper>
        <Text type="secondary" spaceAfter="small">
          Note: Used for routing in Scrooge to test new features. BBE will store the extra with this
          value but append &quot;-mmb&quot; to it before sending to Scrooge.
        </Text>

        <SetBrand />

        <Button onClick={this.handleClear}>Clear settings</Button>

        {showSmartFillOptions && <SmartFillOptionsList />}

        <SaveLoadSplitster />

        <h4>Visitor info</h4>
        <ul>
          <li>
            <strong>Visitor ID: </strong>
            <code>{String(cookies.load(Cookie.USER_ID))}</code>
          </li>
          <li>
            <strong>Branch: </strong>
            <code>{String(window.SP_GLOBALS.RELEASE_INFO.branch)}</code>
          </li>
          <li>
            <strong>Affiliate: </strong>
            <code>{String(Cookies.get("SKYPICKER_AFFILIATE"))}</code>
          </li>
        </ul>

        <h4>Dependencies</h4>
        <ul>
          <li>
            <strong>Nitro: </strong>
            <code>{String(window.SP_GLOBALS.DEPENDENDCIES.nitro)}</code>
          </li>
          <li>
            <strong>Orbit: </strong>
            <code>{String(window.SP_GLOBALS.DEPENDENDCIES.orbit)}</code>
          </li>
          <li>
            <strong>Smart FAQ: </strong>
            <code>{String(window.SP_GLOBALS.DEPENDENDCIES.faq)}</code>
          </li>
          <li>
            <strong>Translations: </strong>
            <code>{String(window.SP_GLOBALS.DEPENDENDCIES.translations)}</code>
          </li>
        </ul>
      </div>
    )
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default connect((state: any) => ({
  showSmartFillOptions: state.options.get("showSmartFillOptions"),
  showConsoleLogs: state.options.get("showConsoleLogs"),
  debugUmbrella: state.options.get("debugUmbrella"),
  fakeCuckoo: state.options.get("fakeCuckoo"),
  bookedAt: getBookedAt(state),
  bookedAtScrooge: getBookedAtScrooge(state),
}))(DebugTools)
